import { asyncDefaults, makeAsyncReducer, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';
import { keysToCamelCase } from '../../../ui-lottery/src/utils/object_utils';
import * as types from '../constants/actions';
import { AccountDefaults } from '../props/account';
import { ApiKeyDefaults } from '../props/apiKey';

const initialData = () => ({
  apiKey: ApiKeyDefaults,
  account: AccountDefaults
});

const fetchAccount = makeAsyncReducer(types.FETCH_ACCOUNT, {
  success(state, action) {
    return { loading: false, loaded: true, data: keysToCamelCase(action.payload), error: null }
  },
  failure(state, action) {
    return { loading: false, loaded: false, data: initialData(), error: action.error };
  }
});
const enableDeveloperAccess = makeAsyncReducer(types.ENABLE_DEVELOPER_ACCESS, {
  // On success we're going to get back a boolean; Make no changes to the state
  success: (state) => ({ loading: false, loaded: true, error: null, data: state.data })
});
const updateAccount = makeAsyncReducer(types.UPDATE_ACCOUNT, {
  // On success we're going to get back a boolean; Make no changes to the state
  success: (state) => ({ loading: false, loaded: true, error: null, data: state.data })
});

export default mergeReducers(
  asyncDefaults(initialData()),
  types.PREFIX,
  fetchAccount, enableDeveloperAccess, updateAccount
);

export const getAccount = (state) => state.portal.accounts.data;
